// extracted by mini-css-extract-plugin
export default {"postList":"postList_DlA1G","item":"item_OyAEu","date":"date_K3bWn","content":"content_jNmMd","link":"link_DV0wV"};